import {
  CONFIRM_MODAL_ACTION,
  CONFIRM_MODAL_ACTION_SUCCESS,
  CONFIRM_MODAL_ACTION_ERROR,
} from "./actionTypes"


export const confirmModalAction = data => ({
  type: CONFIRM_MODAL_ACTION,
  payload: data
});

export const confirmModalActionSuccess = data => ({
  type: CONFIRM_MODAL_ACTION_SUCCESS,
  payload: {data}
});

export const confirmModalActionError = error => ({
  type: CONFIRM_MODAL_ACTION_ERROR,
  payload: error,
});
